import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { EscolherSintomaPage } from '../sintomas/escolhersintoma';
import { AddDependentePage } from '../dependentes/adddependente';

@Component({
  selector: 'escolherdependente',
  templateUrl: 'escolherdependente.html'
})

export class EscolherDependentePage {
	public coord;
	public coord2;
	public coord3;
	public cidade;
	public cidade2;
	public cidade3;
	public estado;
	public estado2;
	public estado3;
	public user;
	public dependente;
	public dependentes: Object;
	public nomeUsuario = localStorage.getItem("nomeUsuario");
	public idUsuario = localStorage.getItem("idUsuario");

	constructor(public navCtrl: NavController, public navParams: NavParams, private http: Http, private alertCtrl: AlertController) {
		this.coord = navParams.get("coord");
		this.coord2 = navParams.get("coord2");
		this.coord3 = navParams.get("coord3");
   		this.cidade = navParams.get("cidade");
   		this.cidade2 = navParams.get("cidade2");
   		this.cidade3 = navParams.get("cidade3");
   		this.estado = navParams.get("estado");
   		this.estado2 = navParams.get("estado2");
   		this.estado3 = navParams.get("estado3");
	}

	ionViewWillLoad(){
	    this.getData();
	}

	getData(){
		this.respGetData().subscribe(data => {
			this.dependentes = data.dependente;
		});
	}

	respGetData(): Observable<any> {
    	return this.http.get("http://maisalguemdoente.com.br/usuariosApp/usuarios/webService/getUsuario?id="+localStorage.getItem("idUsuario")).map((res: Response) => res.json());
  	}

  	addSintoma(){
  		if(!this.dependente){
  			let alert = this.alertCtrl.create({
		 		subTitle: 'Selecione um paciente.',
		        buttons: ['OK']
		      });
		 	alert.present();
  		} else {
	  		if(this.dependente === localStorage.getItem("idUsuario"))
	  			this.dependente = 0;

	  		this.navCtrl.push(EscolherSintomaPage, {
		      coord: this.coord,
		      coord2: this.coord2,
		      coord3: this.coord3,
		      cidade: this.cidade,
		      cidade2: this.cidade2,
		      cidade3: this.cidade3,
		      estado: this.estado,
		      estado2: this.estado2,
		      estado3: this.estado3,
		      user: localStorage.getItem("idUsuario"),
		      dependente: this.dependente
		    });
	  	}
  	}

  	addDependente(){
  		this.navCtrl.push(AddDependentePage, {
			coord: this.coord,
			coord2: this.coord2,
			coord3: this.coord3,
			cidade: this.cidade,
			cidade2: this.cidade2,
			cidade3: this.cidade3,
			estado: this.estado,
			estado2: this.estado2,
			estado3: this.estado3
		});
  	}
}


// WEBPACK FOOTER //
// ./src/pages/dependentes/escolherdependente.ts